import { BaseScript } from "../BaseScript";
import { matchAll } from "../../Utils/unsafe";
import BaseViewModel from "../../../Models/BaseViewModel";
import { ScriptDescriptionType } from "src/Modules/DynamicForm/Types";
import DynamicFormAPI, { GetDictionaryRegistryDataRequestType } from "src/Modules/DynamicForm/API";

export class SearchAttributeScript extends BaseScript {

	attrName: string = '';
	script: string = '';
	//может оптимизировать вместе с конвертацией скриптов
	depsRegex = /hostObject.GetValue\("(.[^"]+)"\)/g;
	ajaxRequest: AbortController | null = null;

	constructor ( contextElement: BaseViewModel, script: ScriptDescriptionType, scriptPurpose: string ) {
		// 	Вызов конструктора родителя.
		super( contextElement, script, scriptPurpose );
		const matches = this.Content?.match(/SearchAttribute: AttrName:([^<>]*) Script:([^<>]*)/i);
		if ( matches && matches.length === 3 ) {
			this.attrName = matches[1];
			this.script = matches[2];
		}
	};

	/**
	 * Парсим скрипт на наличие элементов 
	 */
	getDependentFields = () => {
		if (!this.Content) return [];
		const matches = matchAll(this.Content, this.depsRegex);
		if ( matches ) {
			return matches.map( (item) => item[1] );
		}
		return [];
	};

	/**
	 * Запустить скрипт в контексте hostObject
	 */
	runScript = () => {
		if (!this.Content) return null;
		try {
			return this.runSearchAttributeScript();
		} 
		catch ( e: any ) {
			console.warn( e.message );
		}
		return null;
	};

	runSearchAttributeScript = () => {
		// TODO
		const viewModel = this.contextElement as any;
		
		if ( viewModel.elementDescriptor.DescriptorKey === "DictionaryRegistryControlDescriptor" ) {

			if ( !!this.ajaxRequest ) {
				this.ajaxRequest.abort();
				this.ajaxRequest = null;
			}

			// получаем значение
			window.hostObject = this.hostObject;
			// eslint-disable-next-line
			const scriptValue = eval( this.script );

			const data: GetDictionaryRegistryDataRequestType = {
				fileId: BaseViewModel.fileId,
				componentId: BaseViewModel.componentId,
				DictionaryId: viewModel.DictionaryId ?? "",
				Value: scriptValue,
				AttrName: this.attrName
			};

			DynamicFormAPI.getDictionaryRegistryDataByAttr( data )
				.then( response => {
					if ( !response.hasError ) {
						const itemId = JSON.parse(response.result);
						viewModel.Value(itemId);
					} 
					else {
						console.error('error response for SearchAttribute');
					}
					this.ajaxRequest = null;
				});
		}
		console.warn('element not External Dictionary');
		return null;
	};

};
